import ApplicationSerializer from './application';

export default class UserDocumentLinkSerializer extends ApplicationSerializer {
  attrs = {
    approvalStatus: {
      serialize: false,
    },
    createdAt: {
      serialize: false,
    },
    updatedAt: {
      serialize: false,
    },
  };
}
